import { IRadioItem } from 'components/Inputs/RadioInput';

export const PART_PORTFOLIO_SUGGESTIONS: IRadioItem[] = [
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
];

export const CAP_RATE_SUGGESTIONS: IRadioItem[] = [
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
];
